export default __webpack_public_path__ + "static/media/vip-1.6c25bd7e.gif";